<div class="header-navigation-back">
    <mat-icon (click)="onNavigateToProfile()">arrow_back</mat-icon>
    <span class="title">Insurance</span>
</div>
<div >
    <div class="padding-sides-2x" [innerHTML]="html">
    </div>
</div>